// export type Locale = 'en-US' | 'pl-PL';
export enum Locale {
    'english' = 'en-US',
    'polish' = 'pl-PL'
}